const constants = {
    ALT_TEXT: {
        LIMIT: 100
    }
};

export { constants as INPUT_LIMIT_CONSTANTS };
